import React, {Component} from 'react';
import CdmLayout from '../../templates/cdm';
import _ from 'lodash';
import current_tasks from './../json/current_tasks';
import {NavLink} from "react-router-dom";
import ProgressBar from "../elements/widgets/progress-bar";
import TaskDetail from "../elements/task_detail";

class CdmDetail extends Component {
	render() {
		let activity = _.find(current_tasks.data, {id: _.toInteger(this.props.match.params.id)});
		return <div className="columns is-multiline">
			<div className="column is-10 is-offset-1">
				<div className="column is-12">
					<div className="level">
						<NavLink to="/cdm/inicio" className="button is-cdm-blue is-small"><i className="fa fa-arrow-left" style={{marginRight: '10px'}} /> Volver a mis tareas</NavLink>
					</div>
				</div>
				<div className="column is-12">
					<div className="level cdm-header--dates">
						<div className="level-left">
							<div className="level-item">
								<p className="due-date">
									<span>Fecha límite</span>
									{activity.date_finish}
								</p>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item progress-detail">
								<ProgressBar total={25} detect={100} />
							</div>
						</div>
					</div>
					<div className={`cdm-header ${activity.category.style}`}>
						<div className="cdm-header--details">
							<p className="category">{activity.category.name}</p>
							<p>{activity.duration} días</p>
						</div>
						<div className="cdm-header--title">
							<h1>{activity.title}</h1>
							<div className="modified">
								<p>
									<span>Última modificación</span>
									2018-08-01
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-12">
					<TaskDetail data={activity.tasks} category={activity.category.style} parent={activity.id} />
				</div>
				<hr/>
				<div className="column is-12">
					<div className="activity-details">
						<h5 className="title is-5">Objetivo</h5>
						<div className="content" dangerouslySetInnerHTML={{__html: activity.purpose}} />
					</div>

					<div className="activity-details">
						<h5 className="title is-5">Políticas / Lineamientos</h5>
						<div className="content" dangerouslySetInnerHTML={{__html: activity.rules}} />
					</div>

					<div className="activity-details">
						<h5 className="title is-5">Datos a reportar</h5>
						<div className="content" dangerouslySetInnerHTML={{__html: activity.report_info}} />
					</div>
				</div>
			</div>
		</div>
	}
}

export default CdmLayout(CdmDetail, {
	title: null,
	subnav: {
		icon: 'fa-briefcase',
		name: 'Mis Tareas',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/detail.jsx